import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { ModalSecurityLendingActivationPage } from './modal-security-lending-activation.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  entryComponents: [
    ModalSecurityLendingActivationPage,
  ],
  declarations: [ ModalSecurityLendingActivationPage ],
})
export class ModalSecurityLendingActivationModule {}
